module.exports = __webpack_public_path__ + "static/media/SettingsIllustration.d207bb66.png";